import intl from "react-intl-universal";

import {AppState} from "@stores/AppState";
import { EnqueueSnackbar } from "../../ui/hooks/useNotification";
import { IStorageService } from "../../platform/services/storage/StorageService";
import type { RootStoreModel } from "@stores/RootStore";
import type { WorkspaceModelType } from "@stores/WorkspaceStore";
import { CrudServices } from "../../platform/services/types/ServiceDependencies";

import { importFile } from "./importFile";
import { selectItem } from "../ui/selectItem";

export interface DocumentImportDependencies extends CrudServices {
    workspace: WorkspaceModelType;
    rootStore: RootStoreModel;
    appState: AppState;
}

export const documentImport = (
    dependencies: DocumentImportDependencies,
    files: FileList | File[],
    enqueueSnackbar: EnqueueSnackbar,
    storageService?: IStorageService,
    tenantId?: string,
) => {
    const { workspace, rootStore, appState } = dependencies;
    const promiseAwait: Promise<any>[] = [];
    for (const file of files) {
        promiseAwait.push(importFile(dependencies, workspace, appState, file, storageService, tenantId));
    }
    enqueueSnackbar({
        message: intl.get('import_doc.start_import', {count: promiseAwait.length})
            .d(`Start import of {count, plural, one {# file} other {# files}}.`),
        variant: 'primary',
    });
    Promise.all(promiseAwait).then((resultsArray) => {
        if (promiseAwait.length === 1) {
            const importFileResult = resultsArray[0];
            const itemMST = importFileResult[0]
            enqueueSnackbar({
                message: intl.get('import_doc.success_import_one')
                    .d(`Successfully imported one file.`),
                variant: 'success',
                actionDef : {
                    text: intl.get('import_doc.success_import_view').d("VIEW"),
                    onClick: () => selectItem(rootStore, itemMST.id),
                }
        });
        } else {
            enqueueSnackbar({
                message: intl.get('import_doc.success_import', { count: promiseAwait.length })
                    .d(`Successfully imported {count, plural, one {# file} other {# files}}. Check it out in the sidebar.`),
                variant: 'success',
            });
        }
    });
};
